import React, { useState, useMemo, useEffect } from 'react'
import Header from './Header'
import Game from './Game/Game'
import Lobby from './Lobby/Lobby'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { db } from './firebase'
import { MonopolyContext } from '../contexts/MonopolyContext'
import styled, { createGlobalStyle } from 'styled-components'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { red, green } from '@mui/material/colors'
import { SnackbarProvider } from 'notistack'

const theme = createTheme({
	palette: {
		mode: 'dark',
		text: {
			primary: '#fff',
		},
		red: {
			main: red[500],
		},
		green: {
			main: green[500],
		},
	},
	typography: {
		fontFamily: 'Monopoly, sans-serif',
		fontSize: 20,
	},
})

const GlobalStyle = createGlobalStyle`
	html, body {
		min-width: 100%;
		min-height: 100%;
		margin: 0;
		padding: 0;
	}
	
	body {
		text-align: center;
		background-color: #e74c3c;
		font-family: 'Monopoly', sans-serif;
		font-size: 20px;
	}
`

const M = styled.span`
	position: relative;
	padding: 0 0 0 0.1em;

	&:before {
		content: 'M';
		text-decoration-line: line-through;
		text-decoration-style: double;
	}
`

const Monopoly = props => {
	const base = process.env.PUBLIC_URL,
		[name, setName] = useState(''),
		monopolyProviderValue = useMemo(_ => ({ name, setName, db, M }), [name])

	// load data
	useMemo(_ => {
		if (localStorage.getItem('name')) {
			setName(localStorage.getItem('name'))
		}
	}, [])

	// set data
	useEffect(
		_ => {
			localStorage.setItem('name', name)
		},
		[name]
	)

	return (
		<MonopolyContext.Provider value={monopolyProviderValue}>
			<SnackbarProvider maxSnack={7}>
				<GlobalStyle base={base} />
				<ThemeProvider theme={theme}>
					<Router basename={base}>
						<Header />
						<Routes>
							<Route path={`/game/:roomCode`} element={<Game />} />
							<Route path={`/`} element={<Lobby />} />
						</Routes>
					</Router>
				</ThemeProvider>
			</SnackbarProvider>
		</MonopolyContext.Provider>
	)
}

export default Monopoly
